import i18n from "@microdoing/shared/i18n";
import { PressableOpacity } from "app/components/common";
import { MainText } from "app/components/common/MainText";
import Colors from "app/constants/Colors";
import palette from "app/Theme/Colors";
import theme from "app/Theme/Theme";
import React from "react";
import { StyleSheet, View, Pressable } from "react-native";
import { widthPercentageToDP } from "react-native-responsive-screen";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import ArrowLeftIcon from "./ArrowLeftIcon";

const PADDING_HORIZONTAL = widthPercentageToDP("5%");

const styles = StyleSheet.create({
  main: {
    backgroundColor: "transparent",
    zIndex: 1000,
    marginTop: 25,
    marginBottom: 10,
    bottom: 0,
    position: "absolute",
    width: widthPercentageToDP("100%"),
    paddingHorizontal: PADDING_HORIZONTAL,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  leftArrow: {
    zIndex: 1200,
    alignSelf: "flex-start",
    height: 40,
    opacity: 0,
    minWidth: 1,
    paddingVertical: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  rightArrow: {
    opacity: 0,
    marginLeft: 5,
    zIndex: 1200,
    borderRadius: 25,
    paddingVertical: 3,
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
  },
  arrowDiv: {
    transform: [{ rotate: "180deg" }],
  },
  visible: {
    opacity: 1,
  },
  leftText: {
    marginTop: 2,
    marginLeft: 8,
  },
  visibleLeftArrow: {
    opacity: 1,
  },
  visibleRightArrow: {
    opacity: 1,
  },
  arrow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    borderRadius: 100,
  },
});

interface Props {
  onPressRightArrow: () => void;
  onPressLeftArrow: () => void;
  hasLeftArrow: boolean;
  hasRightArrow: boolean;
}

const BottomCarousel = ({
  onPressRightArrow = () => null,
  onPressLeftArrow = () => null,
  hasLeftArrow = false,
  hasRightArrow = false,
}: Props) => {
  return (
    <View style={styles.main}>
      <PressableOpacity
        isDisabled={!hasLeftArrow}
        onPress={onPressLeftArrow}
        style={[
          styles.arrow,
          styles.leftArrow,
          hasLeftArrow && styles.visibleLeftArrow,
        ]}
      >
        {!!hasLeftArrow && (
          <ArrowLeftIcon color={theme.colors["neutral.400"]} />
        )}
        {!!hasLeftArrow && (
          <MainText
            variant="l4-medium"
            opacity={hasLeftArrow ? 1 : 0}
            marginRight="s"
            color="neutral.400"
            style={[styles.leftText]}
          >
            {i18n.t("previous-action")}
          </MainText>
        )}
      </PressableOpacity>
      <PressableOpacity
        testID="carousel-right-arrow"
        isDisabled={!hasRightArrow}
        onPress={onPressRightArrow}
        style={[
          styles.arrow,
          styles.rightArrow,
          hasRightArrow && styles.visibleRightArrow,
        ]}
      >
        <MainText
          variant="l4-medium"
          opacity={hasRightArrow ? 1 : 0}
          marginRight="s"
          color={hasRightArrow ? "brand.500" : "neutral.500"}
        >
          {i18n.t("next-action")}
        </MainText>
        {!!hasRightArrow && (
          <View style={styles.arrowDiv}>
            <ArrowLeftIcon color={theme.colors["brand.500"]} />
          </View>
        )}
      </PressableOpacity>
    </View>
  );
};

export default BottomCarousel;
